import { Platform ,Keyboard } from 'react-native';
import { useEffect, useState } from 'react';
import axios from 'axios';
import OTPVerification from '../../sharedComponents/OTPInput/OTPInput';
import { endpoints } from '../../api/apis';
import { useTranslation } from 'react-i18next';
import KeyboardDismissView from '@hoc/KeyboardDismissView';
import { ThemedText, ThemedView } from '../../theme';
import { NativeStackScreenProps } from '@react-navigation/native-stack';
import { PublicStackParamList } from '../../navigationApp/types';
import ScreenWrapper from '@hoc/ScreenWrapper';
import ThemedTouchableOpacity from '../../theme/Components/ThemedTouchableOpacity';

import { useAppDispatch, useAppSelector } from '../../store/hooks'
import { setAppHeader } from '@app/utils';
import { removePathFromUrlWithouReload } from '@voltmoney/micro-frontend';


type ScreenProps = NativeStackScreenProps<PublicStackParamList, 'LOGIN_OTP_SCREEN'>

const LoginOTPScreen = ({
  navigation,
  route,
}: ScreenProps) => {
  const otplength = 6;
  const [hasError, setHasError] = useState<string>('');
  const [verifying, setVerifying] = useState<boolean>(false);
  const [isBlocked, setIsBlocked] = useState(false);

  const isErrorSheetVisible = useAppSelector((state) => state?.errorSheet?.isErrorSheetVisible);

  const dispatch = useAppDispatch();
  const { t } = useTranslation('translation', {
    keyPrefix: route?.name as String,
  });

  useEffect(() => {
    if(isErrorSheetVisible) {
      setVerifying(false)
    }
  } , [isErrorSheetVisible] )

  let isDarkMode: boolean | null = null;
  if (Platform.OS === 'web') {
    const params = new URLSearchParams(window.location.search);
    isDarkMode = params.get('isDarkMode') === 'true';
  }

  const submitOtp = (OTP: string) => {
    const url = endpoints.verifyLoginOTP;
    const payload = {
      otp: OTP,
      phoneNo: '+91' + route.params.phoneNumber,
    };
    axios
      .post(url, payload, { handleFromMF: true })
      .then(res => {
        setAppHeader(res.data.jwt)
      })
      .catch(err => {
        setHasError(err?.data?.message);
        setVerifying(false);
        if (
          err?.status === 400 &&
          err?.data?.voltErrorCode === 'ACCOUNT_BLOCKED_FROM_OTP'
        ) {
          setIsBlocked(true);
        }
      })
  };

  const handleOtpInput = (otp: string[]) => {
    if (isBlocked) {
      return;
    }

    const OTP = otp.join('');
    if (OTP.length === otplength) {
      Keyboard.dismiss();
      setVerifying(true);
      if(Platform.OS === 'web') {
        removePathFromUrlWithouReload("?startnew=true")
      }
      setTimeout(()=>{
        submitOtp(OTP);
      },300)
    } else if (OTP.length > 0 && hasError !== '') {
      setHasError('');
    }
  };

  const triggerResendOTP = (): void => {
    const url = `${endpoints.generateLoginOTP}/+91${route.params.phoneNumber}?enableWhatsapp=true`;
    setHasError('');
    axios
      .get(url)
      .then(res => {
        console.log('senOTP', res);
      })
      .catch(err => {
        setHasError(err?.data?.message);
        console.log('err', err);
        if (
          err?.status === 400 &&
          err?.data?.voltErrorCode === 'ACCOUNT_BLOCKED_FROM_OTP'
        ) {
          setIsBlocked(true);
        }
      });
  };

  const onEdit = (): void => {
    navigation.goBack();
  };

  return (
    <ScreenWrapper screenName={route?.name} additionalProperties={{newArchRoute : true}}>
      <KeyboardDismissView>
        <ThemedView backgroundColor="bg-surface-primary" flex={1} padding="lg">
          <ThemedView mt="2xl" />
          <ThemedText color='text-primary' variant='h3b'>{t('heading')}</ThemedText>
          <ThemedView
            alignItems="center"
            flexDirection="row"
            mt="xs"
            mb="2xl">
            <ThemedText color='text-secondary' variant='b3r'>{t('subHeading')} </ThemedText>
            <ThemedText mr='sm' color='text-secondary' variant='b3b'>{route?.params?.phoneNumber as string}</ThemedText>
            <ThemedTouchableOpacity eventName='EDIT_PHONE_BUTTON' onPress={onEdit}>
              <ThemedText mr='sm' color='text-action-primary' variant='b3s'>{t('Edit')}</ThemedText>
            </ThemedTouchableOpacity>
          </ThemedView>
          <OTPVerification
            noOfDigits={otplength}
            hasError={hasError}
            handleOtpInput={handleOtpInput}
            resendTimerCount={15}
            triggerResendOTP={triggerResendOTP}
            verifying={verifying}
            blockResend={isBlocked}
            isDarkMode={Boolean(isDarkMode)}
          />
        </ThemedView>
      </KeyboardDismissView>
    </ScreenWrapper>
  );
};

export default LoginOTPScreen;
